export default __webpack_public_path__ + "static/media/login-poster.7a177d8a.svg";